export const RIGHT_STATUS = {
  DRAFT: 'draft',
  UPCOMING: 'upcoming',
  LIVE: 'live',
  COMPLETED: 'completed',
  DELAYED: 'delayed',
  WITH_ISSUES: 'with_issues'
}

export const rightOptionsList = [
  { value: RIGHT_STATUS.DRAFT, label: 'Draft (hidden from partner)' },
  { value: RIGHT_STATUS.UPCOMING, label: 'Upcoming' },
  { value: RIGHT_STATUS.LIVE, label: 'Live' },
  { value: RIGHT_STATUS.COMPLETED, label: 'Completed' },
  { value: RIGHT_STATUS.DELAYED, label: 'Delayed' },
  { value: RIGHT_STATUS.WITH_ISSUES, label: 'With Issues' }
]
